<template>
<FormRow class="designation" inline>
  <FormSelect field="custom.designation">
    <option selected="selected" value="General Donation">General Donation</option>
    <option value="Zula">Pearl and Harold Jacobs Zula Outreach Center</option>
    <option value="Womens Division">Women's Division</option>
    <option value="Torah Initiatives">Torah Initiatives</option>
    <option value="NCSY Israel">NCSY Israel</option>
    <option value="Camp Dror">Camp Dror</option>
    <option value="Torah Tidbits">Torah Tidbits</option>
    <option value="OU Kashrut">OU Kashrut</option>
    <option value="Yachad Israel">Yachad Israel</option>
  </FormSelect>

  <FormSelect field="custom.subDesignation" v-if="getValue('custom.designation') == 'Zula'">
    <option selected="selected" value="General Zula">General Zula</option>
    <option value="Liba Banim">Liba Banim</option>
    <option value="Liba Banot">Liba Banot</option>
    <option value="Zusha">Midreshet Zusha</option>
  </FormSelect>

  <ErrorLabel field="custom.designation" style="text-align:right"/>
</FormRow>
</template>
<script lang="ts">
import {
  defineComponent,
  watch
} from 'vue';
import { usePaymentForm } from '@/shared/use-payment-form'
import FormLabel from '~/components/form-label.vue';

export default defineComponent({
  setup() {
    const { getValue } = usePaymentForm()

    return {
      getValue,
    }
  },
})
</script>
<style scoped lang="scss">
.designation {
  display: flex;
  width: 100%;
  position: relative;
  ::v-deep select {
    flex: 1;
    min-width:50%;
    max-width:50%;
    margin-right: 1%;
  }
  ::v-deep select:last-child {
    margin-right: 0;
  }
}
</style>
